import script from "./SpecialistFullCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./SpecialistFullCalendar.vue?vue&type=script&setup=true&lang=js"

import "./SpecialistFullCalendar.vue?vue&type=style&index=0&id=180133c3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-180133c3"]])

export default __exports__